<template>
<div class="invest-main">
    <div class="card">
        <div class="title">温馨提示：</div>
        <p>1.如果您激活的为积分卡：</p>
        <p>(1) 您充值到账户里的积分自激活之日起1年内有效，请尽快使用</p>
        <p>
            (2) 您的积分卡一旦被激活，将充值到<span>当前登录的账户内，请牢记并妥善保管您的账号和密码。</span>
        </p>
        <p>
            2.如果您激活的为积分定制卡，您的定制卡一旦被激活，有效期为30天，只可兑换对应礼品，请根据提示进行兑换。
        </p>
        <p>
            3.无卡用户如果想要获取积分卡或者定制卡，请关注海尔各个销售渠道的营销活动，可现场了解获取详情。
        </p>
    </div>
    <div class="title">请完善用户信息</div>
    <p>为确保您的权益，防止卡被冒充，请<span>填写真实姓名</span>！</p>
    <div class="investinput">
        <van-cell-group>
            <van-field v-model="name" label="姓名" placeholder="请输入用户名" />
            <van-field v-model="phone" label="电话" placeholder="请输入手机号" @blur="validPhone()" />
        </van-cell-group>
    </div>
    <div v-if="this.cardSort == 2 || this.cardSort == 3">
        <div class="title">发票信息</div>
        <div class="span">发票全部信息清晰可见</div>
        <div class="item">
            <div class="label">上传发票：</div>
            <div class="photo">
                <van-uploader v-model="fileList" max-count="1" :after-read="afterRead" />
            </div>
        </div>
    </div>

    <van-button round block color="var(--theme-color-main)" @click="submit()" type="primary" class="b-button" style="margin-top: 15px;">激活</van-button>
</div>
</template>

<script>
import {
    activateCardPoint,
    uploadImg,
    getPointCardPasswordAndCardNo,
    UserTokens,
    getUserInfo,
    getPointCardExit
} from "@/api/api";
export default {
    data() {
        return {
            fileList: [],
            name: "",
            phone: "",
            cardNo: "", //卡号
            passWord: "", //卡密
            imgUrl: null,
            token: "",
            cardSort: "",
            id: "",
            cardPassword: ""
        };
    },

    methods: {
        // goacriva(){
        //   this.$router.push({
        //     path: "/activation",
        //   });
        // }
        async afterRead(file) {
            // 此时可以自行将文件上传至服务器
            var formData = new FormData();

            //可以通过append()方法来追加数据
            formData.append("file", file.file);
            console.log(formData);
            const res = await uploadImg(formData);
            if (res.code == "0000") {
                this.imgUrl = res.data;
            }
        },
        validPhone() {
            if (!/^1[3456789]\d{9}$/.test(this.phone)) {
                this.$toast("请输入正确的手机号");
                return;
            }
        },
        //获取卡号卡密
        async pointCardExit() {
            let params = {
                id: this.$cookies.get("id"),
            };
            let pointCard = await getPointCardPasswordAndCardNo(params);
            if (pointCard.code == "0000") {
                // this.$toast(pointCard.msg);
                this.cardSort = pointCard.data.cardSort;
                this.cardNo = pointCard.data.cardNo;
                this.passWord = pointCard.data.passWord;
                console.log(this.cardSort)
                console.log(this.cardNo)
                console.log(this.passWord)

                this.$cookies.set("cardSort", this.cardSort);
                this.$cookies.set("cardNo", this.cardNo);
                this.$cookies.set("passWord", this.passWord);

            }
            // console.log(this.cardSort);
        },
        //获取卡状态
        async CardExit() {
            let params = {
                cardNo: this.$cookies.get("cardNo"),
            };
            let pointCard = await getPointCardExit(params);
            if (pointCard.code == "0000") {
                // this.$toast(pointCard.msg);
                this.cardSort = pointCard.result.cardSort;

                this.$cookies.set("cardSort", this.cardSort);

            }
            // console.log(this.cardSort);
        },
        async submit() {
            console.log(this.cardSort)
            console.log(this.cardNo)
            console.log(this.passWord)
            if (!this.name) {
                this.$toast("请输用户名");
                return;
            }

            if (!this.phone) {
                this.$toast("请输入手机号");
                return;
            }

            if (!/^1[3456789]\d{9}$/.test(this.phone)) {
                this.$toast("请输入正确的手机号");
                return;
            }

            if (this.imgUrl == null && (this.cardSort == 2 || this.cardSort == 4)) {
                this.$toast("请上传发票图片");
            }

            let params = {
                memberId: this.$cookies.get("memberId"),
                memberName: this.name,
                cardNo: this.$cookies.get("cardNo"),
                cardPassword: this.$cookies.get("passWord") || this.$cookies.get("cardPassword"),
                mobileNo: this.phone,
                imageUrl: this.imgUrl,
            };
            let pointCard = await activateCardPoint(params);
            if (pointCard.code == "0000") {
                // this.$router.push({
                //     path: 'Activationsuccessful',
                //     query: {
                //         msg: pointCard.msg,
                //     }
                // });
                this.$toast("申请成功！");
            } else {
                this.$toast(pointCard.msg);
            }

            // this.showPicker = true;
        },
        async getUserInfo() {
            let params = {};
            let userInfo = await getUserInfo(params);
            this.$cookies.set("memberId", userInfo.data.idsUserId);
            this.$cookies.set("memberName", userInfo.data.username);
            this.$cookies.set("memberPhone", userInfo.data.cellphoene);
            console.log(userInfo.data.idsUserId)
            console.log(userInfo.data.username)
            console.log(userInfo.data.cellphoene)
        },

        //获取用户token
        appInit() {
            console.log("1")

            if (this.$cookies.get("hbscToken") != null) {
                console.log("2")

                this.token = this.$cookies.get("hbscToken");
                // console.log(11);
            } else {
                console.log("3")

                let url = window.location.href;
                let code = url.match(/code=(\S*)&/);
                console.log(code)

                if (code == undefined) {

                    //如果没有token，url上是否有code，无code，跳转登录
                    let Url = "https://jf.haier.com/m/#/Integralcard";

                    var Url2 = encodeURIComponent(Url);

                    //测试环境地址
                    window.location.href =
                        "https://account.haier.com/oauth/authorize?client_id=haibeishangcheng&response_type=code&state=xyz" +
                        "&redirect_uri=" +
                        Url2;
                    console.log("4")

                    console.log(Url)

                } else {
                    this.code = code[1];
                    console.log(this.code)
                    console.log("5")
                    this.getUserToken();
                }
                // if (this.$cookies.get("hbscToken") == null && this.code !== null) {

                // }

                // console.log(44);
            }
            // console.log(55);
        },
        async getUserToken() {
            console.log("6")

            console.log("进去获取token接口");

            let params = {
                code: this.code,
                clt: "h5",
            };
            console.log("7")

            console.log(this.code);
            console.log("正在调用token接口");

            const res = await UserTokens(params);
            console.log("调用token接口中");

            if (res.code == "0000") {
                if (res.result) {
                    var hbscToken = res.result || ''
                    this.$cookies.set("hbscToken", hbscToken);
                    console.log(hbscToken)
                    this.getUserInfo();
                }

            } else {
                console.log("调用token接口失败");

            }
        },
    },

    mounted() {
        let url = window.location.href;
        console.log(url)
        if (url.indexOf("cardNo") > -1 ||(this.$cookies.get("cardNo") != "" && this.$cookies.get("cardNo") != null )) {
            if (this.$route.query.cardNo !== undefined) {
                this.cardNo = this.$route.query.cardNo;
                this.$cookies.set("cardNo", this.cardNo);

                // console.log(this.cardPassword);
            }
            if (this.$route.query.cardPasswrod !== undefined) {
                this.cardPassword = this.$route.query.cardPasswrod;
                this.$cookies.set("cardPassword", this.cardPassword);

                // console.log(this.cardPassword);
            }
            console.log("huoqutiken")
            this.appInit();

            this.CardExit();
        } else if (this.$route.query.id !== undefined ||(this.$cookies.get("id") != "" && this.$cookies.get("id") != null )) {
            this.id = this.$route.query.id;
            this.$cookies.set("id", this.id);
            // console.log(this.cardNo);
            console.log("huoqutiken")

            this.appInit();

            this.pointCardExit();
        } else {
            console.log("else")
        }

    },
};
</script>

<style lang="scss" scoped>
/deep/.van-button__text {
    color: white;
}

.item {
    padding-top: 20px;
    display: flex;

    .label {
        width: 180px;
        font-size: 26px;
        text-align: center;
    }
}

.span {
    color: red;
    text-align: center;
}

.invest-main {
    background-color: #fff;
}

.step {
    background-color: #fff;
}

/deep/.van-steps--horizontal {
    width: 80%;
    margin: 0 auto;
}

.card {
    background-color: #fff;

    padding-top: 20px;
}

.title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 20px;
    padding-top: 30px;
}

p {
    width: 600px;
    margin: 0 auto;
    font-size: 17px;
    line-height: 35px;
}

span {
    color: red;
}

.investinput {
    padding-top: 30px;
}
</style>
